//import $ from 'jquery';
import DocReady from '../modules/_doc-ready';
new DocReady( () => {
    const flavorSelect = document.querySelectorAll('.choose-deal__flavor-select');
        if(flavorSelect != undefined) {
            flavorSelect.forEach( ele =>  {
                // Now do something
                const mainBlock = ele.closest('.choose-deal__block');
                const mainBlockSelect = mainBlock.querySelector('select');
                mainBlockSelect.addEventListener("change", function() {
                    var e = mainBlockSelect;
                    var selected = e.options[e.selectedIndex].value;
                    var flavor = e.options[e.selectedIndex].dataset.flavor;
                    function make_arr(arr) {
                        let ele = mainBlock.querySelector('.' + arr);
                       
                        if(ele !== undefined && ele !== null){
                            //console.log(res, arr, '2ppp');
                            let res = ele.dataset[arr];
                            res = res.trim();
                            res = res.replace(/\n|\r/g, "");
                            let res_arr = res.split('||||');
                            return res_arr;
                        } else {
                            return null;
                        }
   
                    }

                    function searchVariant(set, flavor){
                        if(set !== undefined && set !== null){
                            let endSet = [];
                            set.forEach( ele =>  { 
                                    if(ele != '' && ele != undefined && ele.includes(flavor)){
                                        endSet.push(ele);
                                    }
    
                            })
                            replaceValues(endSet);
                            //console.log(flavor);
                        }

                    }

                    let _variants = make_arr('variants');
                    
                    let set1 = make_arr('set1');
                    let set2 = make_arr('set2');
                    let set3 = make_arr('set3');
                    let set4 = make_arr('set4');

                    searchVariant(set1, flavor);
                    searchVariant(set2, flavor);
                    searchVariant(set3, flavor);
                    searchVariant(set4, flavor);


                    function replaceValues(set){
                        const variants = mainBlock.querySelectorAll('.variant');
                        let vars = [], set_arr, chooseCount = 0;
                        variants.forEach( ele =>  {
    
                            if(set[chooseCount] != undefined) {
                                //console.log('xkkkk ', set[chooseCount]);

                                set_arr = set[chooseCount].split('--');
                                //console.log('ccccc',set_arr);

                                vars['id'] = set_arr[0].split(':::')[1].trim();
                                vars['title'] =  set_arr[1].split(':::')[1];
                                vars['save'] =  set_arr[2].split(':::')[1];
                                vars['full_retail'] =  set_arr[3].split(':::')[1];
                                vars['sale_price'] =  set_arr[4].split(':::')[1];
                                vars['using_code'] =  set_arr[5].split(':::')[1];
                                vars['limited_time_offer'] =  set_arr[6].split(':::')[1];
                                vars['pack_text'] =  set_arr[7].split(':::')[1];


                                ele.querySelector(".variant__save").innerHTML= vars['save'];      
                                ele.querySelector("[name='id']").value = vars['id'];         
                                ele.querySelector(".variant__title").innerHTML= vars['title'];   
                                ele.querySelector(".variant__full-price").innerHTML = vars['full_retail'];    
                                ele.querySelector(".variant__sale-price").innerHTML = vars['sale_price'];    
                                ele.querySelector(".variant__total-price").innerHTML = vars['using_code'];    
                                ele.querySelector(".variant__limited").innerHTML = vars['limited_time_offer'];    
                                ele.querySelector(".landing-button").value = vars['pack_text'];         
                                chooseCount++;
                            }
                        });//end foreach
                    }
                });          
            });
        }
});

                               